import { render } from "./MatrixBoard.vue?vue&type=template&id=740b2eae&scoped=true"
import script from "./MatrixBoard.vue?vue&type=script&lang=js"
export * from "./MatrixBoard.vue?vue&type=script&lang=js"

import "./MatrixBoard.vue?vue&type=style&index=0&id=740b2eae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-740b2eae"]])

export default __exports__